import * as CardCrawl from "@ravalmatic/cardcrawl-engine";
import { Card } from "./Card";
import { BoardContainer } from "../BoardContainer";
import { FX } from "./FX/FX";

export class PlayerCard extends Card {

    private static f = 0;

    private static readonly ALPHA_GLOW_VALUES = [
        [0, 0, 0],      // 0  
        [1, 0, 0],      // 1
        [0, .2, 0],     // 2 
        [1, .4, 0],     // 3
        [1, .5, .1],    // 4
        [1, .6, .2],    // 5
        [1, .7, .3],    // 6
        [1, .8, .4],    // 7
        [1, .9, .5],    // 8
        [1, 1, .6],     // 9
        [1, 1, .7],     // 10
        [1, 1, .8],     // 11
        [1, 1, .9],     // 12
        [1, 1, 1]       // 13
    ];

    private glowContainer: Phaser.GameObjects.Container;
    private glow1: Phaser.GameObjects.Image;
    private glow2: Phaser.GameObjects.Image;
    private glow3: Phaser.GameObjects.Image;
    private tabLifesContainer: Phaser.GameObjects.Container;    

    constructor(scene: Phaser.Scene, p: {x: number, y: number, angle: number}, cardData: CardCrawl.CardData) {
        
        super(scene, p, cardData);

        this.x = this.px;
        this.y = this.py;

        this.tabLifesContainer = new Phaser.GameObjects.Container(this.scene);
        this.tabLifesContainer.y = 110;
        this.add(this.tabLifesContainer);

        const tabLifes = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", this.cardData.canRevive ? "tab_lifes_2" :  "tab_lifes");
        this.tabLifesContainer.add(tabLifes);

        this.valueLabel.visible = true;
        this.valueLabel.x = -40;
        this.valueLabel.y = -6;
        this.valueLabel.setColor("#663227");
        this.valueLabel.setFontSize(42);
        this.tabLifesContainer.add(this.valueLabel);

        const fixedValueLabel = new Phaser.GameObjects.Text(scene, this.valueLabel.x + 18,  this.valueLabel.y + 2, "/13", {fontFamily: "AlmendraBold", color: "#663227", fontSize: "30px"});
        fixedValueLabel.setOrigin(0, .5);
        this.tabLifesContainer.add(fixedValueLabel);

        this.animatedItems.bringToTop(this.valueLabel);
    }

    public destroy(fromScene?: boolean): void {

        this.glowContainer.destroy();

        super.destroy(fromScene);
    }

    public preUpdate(time: number, delta: number): void {

        // el alfa del glow container oscila entre 1 y .75 cada 2 segundos
        PlayerCard.f ++;

        if (PlayerCard.f === 120) {
            PlayerCard.f = 0;
        }

        this.glowContainer.alpha = .875 + .125 * Math.cos(PlayerCard.f * Math.PI / 60);
    }

    protected spawn(): void {

        this.addGlow();
        
        this.img.setFrame("hero_1");
       
        this.alpha = 0;

        this.scene.tweens.add({
            targets: this,
            alpha: 1, 
            duration: 1250,
            ease: Phaser.Math.Easing.Cubic.Out
        });
    }

    protected onCardReady(): void {

        super.onCardReady();

        // el glow 
        this.addGlow();

        this.x = this.px;
        this.y = this.py;

        const delay = this.cardData.uiData.delay * FX.DELAY;

        if (this.cardData.value !== this.cardData.lastValue) {

            this.scene.time.delayedCall(delay, () => {

                const chain = this.scene.tweens.chain({
                    targets: this.tabLifesContainer,
                    tweens: [
                        {
                            scaleY: 0,
                            ease: Phaser.Math.Easing.Cubic.In,
                            duration: 300
                        },
                        {
                            scaleY: 1,
                            ease: Phaser.Math.Easing.Elastic.Out,
                            duration: 1000,
                        }
                    ]
                });
                chain.play();

            }, [], this);
        } 
    }

    public hideGlow(): void {

        this.scene.tweens.add({
            targets: this.glowContainer,
            alpha: 0,
            duration: 500,
            ease: Phaser.Math.Easing.Cubic.Out,
            onComplete: () => {
                this.glowContainer.visible = false;
            },
            onCompleteScope: this
        });
    }

    private addGlow(): void {

        this.glowContainer = new Phaser.GameObjects.Container(this.scene);
        this.glowContainer.y = 75 + BoardContainer.CARD_HEIGHT / 2;
        BoardContainer.currentInstance.addAt(this.glowContainer, 0);

        this.glowContainer.alpha = .875 + .125 * Math.cos(PlayerCard.f * Math.PI / 60);

        this.glow1 = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "hero_glow_1");
        this.glowContainer.addAt(this.glow1);

        this.glow2 = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "hero_glow_2");
        this.glowContainer.addAt(this.glow2);

        this.glow3 = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "hero_glow_3");
        this.glowContainer.addAt(this.glow3);

        const [alphaGlow1, alphaGlow2, alphaGlow3] = PlayerCard.ALPHA_GLOW_VALUES[this.cardData.lastValue] || [0, 0, 0];
        
        this.glow1.alpha = alphaGlow1;
        this.glow2.alpha = alphaGlow2;
        this.glow3.alpha = alphaGlow3;

        if (this.cardData.lastValue !== this.cardData.value) {

            const [alphaGlow1, alphaGlow2, alphaGlow3] = PlayerCard.ALPHA_GLOW_VALUES[this.cardData.value] || [0, 0, 0];

            this.scene.tweens.add({
                targets: this.glow1,
                alpha: alphaGlow1,
                duration: 500,
                ease: Phaser.Math.Easing.Cubic.Out
            });

            this.scene.tweens.add({
                targets: this.glow2,
                alpha: alphaGlow2,
                duration: 500,
                ease: Phaser.Math.Easing.Cubic.Out
            });

            this.scene.tweens.add({
                targets: this.glow3,
                alpha: alphaGlow3,
                duration: 500,
                ease: Phaser.Math.Easing.Cubic.Out
            });
        }
    }
}
